<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير صرف الرواتب عن شهر"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="headerArray"
    >
      <!-- worksheet="page"
      :before-generate="startDownload"
      :before-finish="finishDownload"
      :footer="st5Array" -->
       Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["month", "bankBranch", "date", "name", "desc"],
  data() {
    return {
      json_fields: {
        "الرقم المالي": "financialNumber",
        "ر.م. المالية": "fileNumber",
        الإسم: "employeeName",
        الدرجة: "degree",
        "شهر العلاوة": "bonusDueDate",
        الأساسى: "basicSalary",
        ندب: "0",
        مكأفاءة: "rewards",
        الإجمالى: "totalSalary",
        ضمان: "warrantyTax",
        الدخل: "0",
        الجهاد: "jihadTax",
        الدمغة: "stampTax",
        تضامن: "solidarityTax",
        "نفقة شرعية": "legalExpenseDiscount",
        "ق.سلفة": "creditDiscount",
        "خصم أخرى": "otherDiscounts",
        "خ.عقوبة": "0",
        "خ. غياب": "absanceDiscount",
        "علاوة بالصافى": "totalAllowance",
        خصميات: "totalDiscount",
        "علاوة لجنة": "committeesAllownace",
        "العمل الاضافى": "overTime",
        "صافى المرتبات": "netSalary",
        "الرقم الوطنى": "nationalNumber",
        "علاوة 1": "allowance-1.value",
        "علاوة 2": "allowance-2.value",
        "علاوة 3": "allowance-3.value",
        "علاوة 4": "allowance-4.value",
        "علاوة 5": "allowance-1.value",
        "علاوة 6": "allowance-2.value",
        "علاوة 7": "allowance-3.value",
        "علاوة 8": "allowance-4.value",
      },
      headerArray: [this.date],
      footerArray: ["تقرير حافظة ارفاق صك"],
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }
      if (!this.bankBranch) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال فرع البنك"
        );
      }

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/SalariesReports/SalariesPaymentPerMonth?MonthDate=${
          this.month
        }&BankBranchId=${this.bankBranch}`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      for (let i = 0; i <= 3; i++) {
        res.data.data.items[0].allowances.push({
          key: `name-${i + 1}`,
          value: `val-${i + 1}`,
        });
      }

      let array = res.data.data.items;
      let arr = [];

      array.forEach((el, i) => {
        el.allowances.forEach((item, x) => {
          el[`allowance-${x + 1}`] = item;
        });
        arr.push(el);
        // console.warn("array :::", el);
      });
      return arr;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
  watch: {
    desc(newValue, oldValue) {
      this.headerArray.push(newValue);
    },
    name(newValue, oldValue) {
      this.headerArray.push(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>